import React from "react";
import cn from "classnames";
import styles from "./LoaderTransition.module.scss";

export interface LoaderTransitionProps {
  isPDA?: boolean;
  className?: string;
}
export const LoaderTransition = ({
  isPDA,
  className,
}: LoaderTransitionProps) => {
  return (
    <div className={cn(styles.loader, className, { [styles.pda]: isPDA })} />
  );
};
